<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import StatChart from '@components/widget-stat-chart'
import VueApexCharts from 'vue-apexcharts'
import produtoMixin from '@/src/mixins/produtoMixin'
import pedidoMixin from '@/src/mixins/pedidoMixin'
import dashboardMixin from '@/src/mixins/dashboardMixin'
import alertMixin from '@/src/mixins/alertMixin'
import VueHtml2pdf from 'vue-html2pdf'
import moment from 'moment'

/**
 * Dashboard-1 Component
 */
export default {
  components: { Layout, Loading, StatChart, apexchart: VueApexCharts, VueHtml2pdf },
  mixins: [produtoMixin, pedidoMixin, dashboardMixin, alertMixin],
  data() {
    return {
      isLoading: false,

      pedidoCliente: null,
      tablePedidoCliente: [],

      statusSelected: null,
      statusOptions: [
        { value: null, text: 'Selecione o status', disabled: true },
        { value: 'recebido', text: 'Recebido' },
        { value: 'aprovado', text: 'Pagamento aprovado' },
        { value: 'transporte', text: 'Transporte' },
        { value: 'entregue', text: 'Entregue' },
        { value: 'cancelado', text: 'Cancelado' },
      ],

      pedidos: [],
      pedidosFields: [
        {
          key: 'codigo',
          label: 'Código',
          class: 'size-col-50',
        },

        {
          key: 'usuario',
          label: 'Cliente',
          class: 'size-col-50',
        },

        {
          key: 'status.value',
          label: 'Status',
          class: 'size-col-50',
        },

        {
          key: 'actions',
          label: 'Ações',
          class: 'size-col-50',
        }
      ],
      estoques: [],
      estoqueFields: [
        {
          key: 'nome',
          label: 'Produto',
          class: 'size-col-20',
        },
        {
          key: 'estoque',
          label: 'Quantidade',
          class: 'size-col-20',
        },
      ],
      statChart: [
        {
          mainTitle: 'Total de Usuários',
          value: 0,
          chartColor: '#5369f8',
        },
        {
          mainTitle: 'Total de Produtos',
          value: 0,
          chartColor: '#f77e53',
        },
        {
          mainTitle: 'Total de Estoque',
          value: 0,
          chartColor: '#43d39e',
        },
      ],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: { categories: [] },
      },
      series: [{ data: [], name: 'receitas' }],
    }
  },
  watch: {},
  mounted() {
    this.listaPedido()
    this.listaProduto()
    this.getDashboard()
  },
  methods: {

    getCurrentDate() {
      const currentDate = new Date();

      const day = currentDate.getDate().toString();
      const month = (currentDate.getMonth() + 1).toString();

      let currentDay = day.length > 1 ? day : '0' + day;
      let currentMonth = month.length > 1 ? month : '0' + month;
      let currentYear = currentDate.getFullYear();

      const date = currentDay + '-' + currentMonth + '-' + currentYear;

      let hours = currentDate.getHours().toString();
      let minutes = currentDate.getMinutes().toString();

      const currentHours = hours.length > 1 ? hours : '0' + hours;
      const currentMinutes = minutes.length > 1 ? minutes : '0' + minutes;

      const time = `${currentHours}:${currentMinutes}`;

      const fulltime = date + ' ' + time;
      return fulltime;
    },

    atualizarPedido() {

      this.updatePedido(this.pedidoCliente.id, { status: { value: this.statusSelected }, updated_at: this.getCurrentDate() }).then((res) => {

        const pedidoRecebido = res.data.dados;
        const pedido = this.pedidos.find(pedido => pedido.codigo == pedidoRecebido.codigo);

        if (pedidoRecebido.status.value == 'aprovado')
          pedido.status.value = 'Pagamento aprovado';
        else
          pedido.status.value = pedidoRecebido.status.value;

        this.$bvModal.hide('pedido-form');
        this.successMessage('Status do pedido foi atualizado');
      })
    },

    mostraModalPedido(item) {

      if (item._showDetails) {
        item.showDetails = false
      } else if (item.details) {
        this.$set(item, '_showDetails', true)
      } else {

        const pedido = this.pedidos.find(pedido => pedido.codigo == item.codigo)

        this.pedidoCliente = pedido;

        var tabelaProduto = [];

        this.pedidoCliente.produtos.forEach(produto => {
          if (produto.categoria !== "") {
            tabelaProduto.push({
              nome: produto.nome,
              quantidade: produto.qtd_carrinho,
              valor: produto.valor,
            })
          }
        })

        this.$set(item, '_showDetails', true)
        this.tablePedidoCliente = tabelaProduto;
        this.$bvModal.show('pedido-form');

      }

    },

    listaPedido() {
      this.isLoading = true;
      this.loadPedidos().then((res) => {
        this.pedidos = res.data.dados.map(pedido => {
          let dataAprovado = pedido.historico.find(hist => hist.value === 'aprovado');
          
          if (pedido.status.value == 'aprovado')
            pedido.status.value = 'pagamento aprovado'

          let enderecoCompleto = null;

          if (pedido.usuario.numero) {
            enderecoCompleto = `${pedido.usuario.endereco}, ${pedido.usuario.numero} - ${pedido.usuario.cidade} - ${pedido.usuario.estado}`
          } else {
            enderecoCompleto = `${pedido.usuario.endereco} - ${pedido.usuario.cidade} - ${pedido.usuario.estado}`
          }

          return {
            id: pedido._id,
            codigo: pedido.codigo,
            usuario: pedido.usuario.nome + ' ' + pedido.usuario.sobrenome,
            tipoPessoa: pedido.usuario.valorTipoPessoa,
            enderecoCompleto: enderecoCompleto,
            status: pedido.status,
            produtos: pedido.produtos,
            valorTotal: pedido.valor_total,
            data: dataAprovado !== undefined ? dataAprovado.updated_at : ''
          }
        })

      })
    },

    generateInvoice(item) {
      const pedido = this.pedidos.find(pedido => pedido.codigo == item.codigo)
      this.pedidoCliente = pedido;
      this.$refs.html2Pdf.generatePdf()
    },

    listaProduto() {
      this.isLoading = true
      this.loadProdutos().then((res) => {
        this.estoques = res.data.dados
        this.isLoading = false
      })
    },
    getDashboard() {
      this.isLoading = true
      this.loadDashboards().then(res => {
        let cardsInfo = res.data.dados
        this.statChart[0].value = cardsInfo.usuarios
        this.statChart[1].value = cardsInfo.produtos
        this.statChart[2].value = cardsInfo.estoque
      }).finally(() => {
        this.isLoading = false
      })
    },
    formatDate(date) {
      if (date) {
        return moment.utc(date).format('DD/MM/YYYY')
      } else {
        return ' '
      }
    },
  },
}
</script>

<template>
  <Layout>

    <VueHtml2pdf :show-layout="false" :preview-modal="true" :enable-download="false" :manual-pagination="true" ref="html2Pdf">
      <section v-if="pedidoCliente" slot="pdf-content" class="pdf-invoice">
        <header>

          <div class="client_info">
            <label>CLIENTE: {{ pedidoCliente.usuario }}</label>
            <label>CPF/CNPJ: {{ pedidoCliente.tipoPessoa }}</label>
          </div>

          <img src="@assets/images/logo.png" alt="" height="70" />
        </header>

        <main>
          <h1>Detalhes do pedido</h1>

          <label>Código do pedido: {{ pedidoCliente.codigo }}</label></br>
          
          <label>Data do pedido: {{ pedidoCliente.data }}</label></br>          
          <label>Endereço: {{ pedidoCliente.enderecoCompleto }}</label>

          <hr>

          <h1>Detalhes da Fatura</h1>

          <div class="top">
            <b>Descrição</b>
            <b>Quantidade</b>
            <b>Valor</b>
          </div>

          <hr>

          <div v-for="produto in pedidoCliente.produtos" id="container">           
            <div class="box" id="bluebox">
              <span>{{ produto.nome }}</span>
            </div>

            <div class="box" id="redbox">
              <span>{{ produto.qtd_carrinho }}</span>
            </div>

            <div class="box" id="greenbox">
              <span>{{ produto.valor }}</span>
            </div>
          </div>

          <div class="results">
            <b>Total: R$ {{ pedidoCliente.valorTotal.replace('.', ',') }}</b>
          </div>

        </main>
      </section>
    </VueHtml2pdf>

    <div class="row page-title align-items-center"> </div>
    <div class="row">
      <div v-for="stat of statChart" :key="stat.mainTitle" class="col-md-6 col-xl-4">
        <StatChart :main-title="stat.mainTitle" :value="stat.value" :sub-value="stat.subValue"
          :chart-color="stat.chartColor" />
      </div>
    </div>

    <b-modal id="pedido-form" title="Alterar status do pedido" hide-footer size="lg">

      <b-form class="form-pedido" v-if="pedidoCliente" @submit.prevent.stop="atualizarPedido">

        <div class="header">
          <span class="item">Código do pedido: {{ pedidoCliente.codigo }}</span>
          <span class="item">Cliente: {{ pedidoCliente.usuario }}</span>
          <span class="item">Endereço: {{ pedidoCliente.enderecoCompleto }}</span>
          <span class="item">Status: {{ pedidoCliente.status.value }}</span>
          <!-- <a @click="generateInvoice" href="#">Ver fatura</a> -->
        </div>

        <div class="mt-3">
          <h3>Produtos</h3>
          <b-table striped :items="tablePedidoCliente"></b-table>
          <span class="d-flex justify-content-end font-weight-bold">Valor total: R$ {{ pedidoCliente.valorTotal
          }}</span>
        </div>


        <div class="mt-2">
          <b-form-select v-model="statusSelected" :options="statusOptions"></b-form-select>
          <div class="mt-2 ml-2">Status selecionado: <strong>{{ statusSelected || 'Ainda não selecionado' }}</strong>
          </div>
        </div>

        <b-button v-if="statusSelected === null" variant="primary mt-3" disabled>Atualizar</b-button>
        <b-button v-else variant="primary mt-3" type="submit">Atualizar</b-button>
      </b-form>

    </b-modal>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title mb-4 header-title"> Pedidos </h5>
            <b-table striped hover responsive="sm" borderless bordered outlined small :fields="pedidosFields"
              :items="pedidos">
              <!-- @row-clicked="mostraModalPedido" -->
              <template #cell(actions)="{ item }">
                <button class="btn btn-primary" @click="mostraModalPedido(item)">Detalhes</button>
                <button class="btn button-fatura ml-3" @click="generateInvoice(item)">Fatura</button>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title mb-4 header-title"> Estoque </h5>
            <b-table striped hover responsive="sm" borderless bordered outlined small :items="estoques"
              :fields="estoqueFields" :per-page="perPage">
              <template v-slot:cell(data_vencimento)="row">
                {{
                    formatDate(row.item.data_vencimento) !== 'Invalid date'
                      ? formatDate(row.item.data_vencimento)
                      : row.item.data_vencimento
                }}
              </template>
            </b-table>
            <b-pagination v-model="currentPage" size="md" :total-rows="rows" :per-page="perPage"></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <loading :active.sync="isLoading" color="#111d5e" :can-cancel="false"></loading>
  </Layout>
</template>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 10px;

  .titulo {
    font-size: 25px;
    color: #ed969e;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .subtitulo {
    margin-bottom: 10px;
  }

  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
    width: 150%;
    margin-left: -50%;
    margin-right: -50%;
  }

  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .btn-Amparo {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #ed969e;
    padding: 5px 30px;

    &.botaoTopo {
      float: right;
    }
  }

  .filterButton {
    margin-top: 39px;
    margin-bottom: 10px;
    background-color: #ed969e;
    padding: 5px 30px;
  }
}

.form-pedido {
  .header {
    display: flex;
    flex-direction: column;

    .item {
      font-size: 1.3rem;
      color: #54565c;
    }
  }
}

#container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #f5f3f3;
  padding-bottom: .5rem;
}

.box {
  width: 300px;
  margin: 5px;
}

#bluebox {
  text-align: left;
}

#redbox {
  text-align: center;
}

#greenbox {
  text-align: right;
}

.pdf-invoice header {
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  background-color: #f5f3f3;
}

.pdf-invoice header .client_info {
  display: flex;
  flex-direction: column;
}

.pdf-invoice header .client_info div {
  display: flex;
  flex-direction: column;
}

.pdf-invoice header .client_info label {
  font-size: 1.2em;
}

.pdf-invoice main {
  margin: 2rem;
  margin-top: 3rem;
}

.pdf-invoice main h1 {
  font-size: 1.1rem;
}

.pdf-invoice main .top {
  display: flex;
  justify-content: space-between;
  margin-top: 2rem;
}

.pdf-invoice main .content div {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.pdf-invoice main .content .border {
  border-bottom: 1px solid #f5f3f3;
  padding-bottom: .5rem;
}

.pdf-invoice main .results {
  display: flex;
  justify-content: right;
}

.button-fatura {
  background-color: #0d6efd;
}
</style>
